// Theme utility with cookie persistence and time-based defaults

export const getTimeBasedTheme = (): 'light' | 'dark' => {
  const hour = new Date().getHours();
  // Morning (6 AM - 6 PM) = light mode
  // Evening (6 PM - 6 AM) = dark mode
  return (hour >= 6 && hour < 18) ? 'light' : 'dark';
};

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

export const setCookie = (name: string, value: string, days: number = 365): void => {
  if (typeof document === 'undefined') return;
  
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

export const getInitialTheme = (): 'light' | 'dark' => {
  // 1. Check cookie first (user preference)
  const cookieTheme = getCookie('aura-theme');
  if (cookieTheme === 'light' || cookieTheme === 'dark') {
    return cookieTheme;
  }
  
  // 2. Check localStorage (fallback)
  if (typeof window !== 'undefined') {
    const localTheme = localStorage.getItem('darkMode');
    if (localTheme === 'true') return 'dark';
    if (localTheme === 'false') return 'light';
  }
  
  // 3. Use time-based default
  return getTimeBasedTheme();
};

export const applyTheme = (theme: 'light' | 'dark'): void => {
  if (typeof document === 'undefined') return;
  
  // Apply theme immediately to document
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  
  // Save to both cookie and localStorage
  setCookie('aura-theme', theme);
  localStorage.setItem('darkMode', theme === 'dark' ? 'true' : 'false');
};